import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _LEGACY_OPT_MAP;

import React from "react";
import ExpandableContent, { COLLAPSED_HEIGHT_OPTIONS } from '@nerdwallet/react-expandable-content';
import { TRK_PRODUCT_LOCATION } from './lib/constants'; // options for how much content is visible while content is collapsed

var FOUR_LINES_HEIGHT = 'FOUR_LINES_HEIGHT';
var DRIVER_TITLE_HEIGHT = 'DRIVER_TITLE_HEIGHT';
var contentCollapsedHeights = [DRIVER_TITLE_HEIGHT, FOUR_LINES_HEIGHT];
/**
 * Map of old to new options in expandable content.
 * @deprecated since version `6.6.0`
 */

var LEGACY_OPT_MAP = (_LEGACY_OPT_MAP = {}, _defineProperty(_LEGACY_OPT_MAP, FOUR_LINES_HEIGHT, COLLAPSED_HEIGHT_OPTIONS.FOUR_LINES_HEIGHT), _defineProperty(_LEGACY_OPT_MAP, DRIVER_TITLE_HEIGHT, COLLAPSED_HEIGHT_OPTIONS.DRIVER_TITLE_HEIGHT), _LEGACY_OPT_MAP);
/**
 * Lightweight, wrapper around backported expandable content component.
 * @deprecated since version `6.6.0`
 * @todo - in version `7.0.0` pull in `@nerdwallet/expandable-content` outright.
 */

var ProductCardExpandableContent = function ProductCardExpandableContent(_ref) {
  var analytics = _ref.analytics,
      children = _ref.children,
      className = _ref.className,
      contentCollapsedHeight = _ref.contentCollapsedHeight,
      contentExpandedOnInitialization = _ref.contentExpandedOnInitialization,
      enableAnalytics = _ref.enableAnalytics,
      id = _ref.id,
      omitExpandFunctionalityOnMobile = _ref.omitExpandFunctionalityOnMobile,
      showLessText = _ref.showLessText,
      showMoreText = _ref.showMoreText,
      trkSectionCategory = _ref.trkSectionCategory,
      trkSectionPosition = _ref.trkSectionPosition;
  if (!children) return null;
  return /*#__PURE__*/React.createElement(ExpandableContent, {
    analytics: analytics,
    className: className,
    enableAnalytics: enableAnalytics,
    id: id,
    showMoreText: showMoreText,
    showLessText: showLessText,
    trkSectionPosition: trkSectionPosition,
    collapsedHeight: LEGACY_OPT_MAP[contentCollapsedHeight],
    shouldOmitExpandFunctionalityOnMobile: omitExpandFunctionalityOnMobile,
    isDefaultExpanded: contentExpandedOnInitialization,
    trkSectionCategory: "".concat(trkSectionCategory, "__").concat(TRK_PRODUCT_LOCATION)
  }, children);
};

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  ProductCardExpandableContent.propTypes = {
    /** The id for the component. Will be used for accessibility purposes. (required) */
    id: PropTypes.string.isRequired,

    /** The analytics prop to pass to base ExpandableContent */
    analytics: PropTypes.shape({
      entityName: PropTypes.string
    }),

    /** The body content that will expand */
    children: PropTypes.node,

    /** The class name to apply to the component */
    className: PropTypes.string,

    /** The amount of content visible while content is collapsed */
    contentCollapsedHeight: PropTypes.oneOf(contentCollapsedHeights),

    /** The default expanded state.
        If true, the content will be expanded by default.
        If false, the content will be collapsed by default.
        Defaults to false.
    */
    contentExpandedOnInitialization: PropTypes.bool,

    /**
     * Flag to enable analytics instrumentation
     */
    enableAnalytics: PropTypes.bool,

    /** When true, render only the internal contents on mobile */
    omitExpandFunctionalityOnMobile: PropTypes.bool,

    /** The toggle open/closed text that shows when the accordion is open */
    showLessText: PropTypes.string,

    /** The toggle open/closed text that shows when the accordion is closed */
    showMoreText: PropTypes.string,

    /** The value to use for the tracking param `sectionCategory` */
    trkSectionCategory: PropTypes.string,

    /** The value to use for the tracking param `sectionPosition` */
    trkSectionPosition: PropTypes.number
  };
}

ProductCardExpandableContent.defaultProps = {
  children: null,
  contentCollapsedHeight: FOUR_LINES_HEIGHT,
  contentExpandedOnInitialization: false,
  enableAnalytics: false,
  omitExpandFunctionalityOnMobile: false,
  showLessText: 'Show Less',
  showMoreText: 'Show More'
};
export { DRIVER_TITLE_HEIGHT, FOUR_LINES_HEIGHT };
export default ProductCardExpandableContent;